import { render } from "./SelectedPatientAdministration.vue?vue&type=template&id=4eae9274&scoped=true"
import script from "./SelectedPatientAdministration.vue?vue&type=script&lang=js"
export * from "./SelectedPatientAdministration.vue?vue&type=script&lang=js"

import "./SelectedPatientAdministration.vue?vue&type=style&index=0&id=4eae9274&lang=scss&scoped=true"

import exportComponent from "/home/runner/work/rust-webserver/rust-webserver/frontend/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4eae9274"]])

export default __exports__